import React from 'react'
import moment from 'moment'
import { Checkbox } from 'material-ui-effco'
import { TableCell, TableRow } from 'material-ui'
import Media from 'react-media'

moment.locale('pl')

const ListViewAttendancesHeader = props => {
  const { togglePupilSelectAll } = props
  const {
    multiSelect: { visible, selectAllChecked },
    data: { pupils },
    selectedGroup
  } = props.data

  const pupilIds = pupils.map(p => p._id)

  return (
    <TableRow>
      {visible ? (
        <TableCell padding="dense" checkbox>
          <Checkbox
            checked={selectAllChecked}
            onCheck={() => togglePupilSelectAll(selectAllChecked, pupilIds)}
          />
        </TableCell>
      ) : null}
      <TableCell padding="dense">Imię i Nazwisko</TableCell>
      <Media query="(min-width: 1200px)">
        <TableCell padding="dense" numeric>
          Prognoza
        </TableCell>
      </Media>
      <Media query="(min-width: 1200px)">
        <TableCell padding="dense" numeric>
          Wpłaty
        </TableCell>
      </Media>
      <Media query="(min-width: 1200px)">
        <TableCell padding="dense" numeric>
          Należność
        </TableCell>
      </Media>
      {selectedGroup.classes.map(cl => (
        <TableCell
          key={cl._id}
          padding="none"
          style={{
            width: 35,
            textAlign: 'center'
          }}
        >
          <div>{moment(cl.date).format('DD')}</div>
          <div>{moment(cl.date).format('MMM')}</div>
        </TableCell>
      ))}
      <TableCell padding="dense" />
    </TableRow>
  )
}

export default ListViewAttendancesHeader
